import { render, staticRenderFns } from "./OrganizationInfoSettings.vue?vue&type=template&id=2beeeb5a&"
import script from "./OrganizationInfoSettings.vue?vue&type=script&lang=js&"
export * from "./OrganizationInfoSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports